import { DETAIL_WIDE_VALUE_CHARS } from '../../../../constants';

export const isDetailValueWide = (value: unknown): boolean =>
  String(value).length > DETAIL_WIDE_VALUE_CHARS;
